"use client";

import { Flex, IconButton } from "@chakra-ui/react";
// import { useState } from "react";
import { LuChevronLeft, LuChevronRight } from "react-icons/lu";

const pageSlot = 500;

const PaginationComp = ({
  pageSize,
  activePage,
  onChange,
  itemsLength,
  limit,
}) => {
  // const [pages, setPages] = useState(() => {
  //   const res = [];
  //   for (let i = 1; i <= pageSize; i++) {
  //     res.push({
  //       key: `page-${i}`,
  //       label: i,
  //     });
  //   }
  //   return res;
  // });
console.log(limit);

  if (limit > 0) {
    return <Flex />;
  }

  if (itemsLength === pageSlot || activePage > 1) {
    return (
      <Flex mt={"1rem"} gap={"0.5rem"}>
        <IconButton
          variant={"outline"}
          onClick={(e) => onChange({ page: activePage - 1 })}
          disabled={activePage === 1}
        >
          <LuChevronLeft />
        </IconButton>

        <IconButton variant={"plain"}>
          {/* {activePage > 1 ? 
        () => {
          let res = 0;
          const v1 =  activePage * slotSize;
          return activePage;
        }
        
         : 0} {' - '}
        {activePage > 1 ? activePage * slotSize : itemsLength} */}
          {activePage}
        </IconButton>

        <IconButton
          variant={"outline"}
          onClick={(e) => onChange({ page: activePage + 1 })}
          disabled={itemsLength !== pageSlot}
        >
          <LuChevronRight />
        </IconButton>
      </Flex>
    );
  }

  return <Flex />;
};

// const PaginationCompX1 = ({ pageSize, activePage, onChange }) => {
//   const [pages, setPages] = useState(() => {
//     const res = [];
//     for (let i = 1; i <= pageSize; i++) {
//       res.push({
//         key: `page-${i}`,
//         label: i,
//       });
//     }
//     return res;
//   });

//   return (
//     <Flex mt={"1rem"}>
//       <Pagination.Root count={0} pageSize={0} defaultPage={1}>
//         <ButtonGroup variant="ghost" size="sm">
//           {/* <Pagination.PrevTrigger asChild>
//           <IconButton>
//             <LuChevronLeft />
//           </IconButton>
//         </Pagination.PrevTrigger> */}

//           {/* <Pagination.Item
//           render={(page) => (
//             <IconButton variant={{ base: "ghost", _selected: "outline" }}>
//               {page.value}
//             </IconButton>
//           )}
//         /> */}
//           {pages.map((a) => (
//             <IconButton
//               key={a.key}
//               onClick={(e) => onChange({ page: a.label })}
//               variant={{ base: activePage === a.label ? "solid" : "outline" }}
//             >
//               {a.label}
//             </IconButton>
//           ))}

//           {/* <Pagination.NextTrigger asChild>
//           <IconButton>
//             <LuChevronRight />
//           </IconButton>
//         </Pagination.NextTrigger> */}
//         </ButtonGroup>
//       </Pagination.Root>
//     </Flex>
//   );
// };

export default PaginationComp;
